/* NOTE: If using nested routes, define in decreasing order of hierarchy with base route at last in routes.js  */
import { ENV } from 'utils/config';
import { oneAppUrl } from 'utils/urlGenerator';

const routeConfig = {
  ROOT: '/',
  AUTH: {
    layout: '/auth',
    LOGIN: {
      path: '/login',
    },
    // RESET: {
    //   path: '/reset',
    // },
  },
  SETTINGS: {
    layout: 'settings',
    LOGISTICS: {
      path: 'logistics',
    },
    ORGANISATION: {
      path: 'organisation',
    },
    CONFIGURATION: {
      path: 'configuration',
    },
    LOCATION_CONFIG: {
      path: 'system-configurations',
    },
    INTERNAL_CONFIGURATION: {
      path: 'internal-configuration',
    },
    ACCOUNT: {
      path: 'account',
    },
    INTEGRATIONS: {
      path: 'integrations',
    },
    TEAM: {
      path: 'team',
    },
    INVITES: {
      path: 'invites',
    },
    NOTIFICATION: {
      path: 'notification',
    },
    PRODUCTS: {
      path: 'products',
    },
    DEVELOPERS: {
      path: 'developers',
    },
  },
  STORES: {
    layout: 'stores',
    LIST: {
      path: 'list',
    },
    NEW: {
      path: 'new',
    },
    ERROR_ACCESS_DENIED: {
      path: 'err_access_denied',
    },
  },
  ANALYTICS: {
    layout: 'dashboard',
    HOME: {
      path: 'home',
    },
    PROFILE: {
      path: 'profile',
    },
  },
  CUSTOMERS: {
    layout: 'customers',
    customers: {
      path: '',
    },
  },
  PAYMENTS: {
    layout: 'payments',
    transactions: {
      path: 'transactions',
    },
    tips: {
      path: 'tips',
    },
    refunds: {
      path: 'refunds',
    },
  },
  APPLICATION_CENTER: {
    layout: 'application_center',
    document_management: {
      path: 'document_management',
    },
    one_app: {
      path: oneAppUrl(ENV || 'production'),
    },
  },
  VIRTUAL_TERMINALS: {
    layout: 'virtualTerminals',
    checkout: {
      path: 'virtual-terminal',
    },
  },
  DEVELOPERS: {
    layout: 'developers',
    API_KEYS: {
      path: 'keys',
    },
    SESSIONS: { path: 'sessions' },
    EVENTS: {
      path: 'events',
    },
    WEBHOOK: {
      path: 'webhooks',
    },
    DOCUMENTATION: {
      path: 'https://payswifter.readme.io/',
    },
  },
  VERIFICATION: {
    path: '/verification',
  },
  PARTNER_STORES: {
    layout: 'partner_stores',
    stores: {
      path: '',
    },
  },
  PARTNER_TRANSACTIONS: {
    layout: 'transactions',
    transactions: {
      path: '',
    },
  },
  MARKETPLACE: {
    layout: 'marketplace',
    marketplace: {
      path: '',
    },
  },
};
export default routeConfig;
